export default __webpack_public_path__ + "static/media/sample_1.a03f7436.png";